/**
 * Base class for search form components
 * Provides common functionality for search inputs
 */
class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    
    if (this.input) {
      this.input.form.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
    }
    
    if (this.resetButton) {
      this.resetButton.addEventListener('click', this.onFormReset.bind(this));
    }
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();
    if (!searchTerm.length) {
      if (this.resetButton) {
        this.resetButton.classList.add('hidden');
      }
    } else {
      if (this.resetButton) {
        this.resetButton.classList.remove('hidden');
      }
    }
  }

  onFormReset() {
    this.input.value = '';
    if (this.resetButton) {
      this.resetButton.classList.add('hidden');
    }
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

// Export to global scope
window.SearchForm = SearchForm;